export default __webpack_public_path__ + "static/service-datavis-7e9037e74bbdf183492219175ef994af.svg";